import { render, staticRenderFns } from "./DevList.vue?vue&type=template&id=195ce328&scoped=true&"
import script from "./DevList.vue?vue&type=script&lang=js&"
export * from "./DevList.vue?vue&type=script&lang=js&"
import style0 from "./DevList.vue?vue&type=style&index=0&id=195ce328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ce328",
  null
  
)

component.options.__file = "DevList.vue"
export default component.exports